import { jsx as T, jsxs as B } from "react/jsx-runtime";
import { c as W, g as bn } from "../../_commonjsHelpers-ByX85dGu.js";
import { forwardRef as yn, useMemo as gn, useState as K, useEffect as oe, useRef as ce, useCallback as qn, useImperativeHandle as mn } from "react";
import { r as Cn } from "../../index-CJ0TdoNN.js";
import { r as Rn, p as On, q as Tn } from "../../index-CExbjDCE.js";
import { t as M } from "../../bundle-mjs-DoW15_-f.js";
import { datePickerTheme as rt } from "./theme.js";
import { getFirstDateInRange as tt, Views as y, getFormattedDate as X, WeekStart as An, isDateEqual as jn, addYears as Z, addMonths as In, startOfYearPeriod as Q } from "../../utils/datepicker.js";
import { DatepickerContext as wn } from "./DatepickerContext.js";
import { TextInput as Sn } from "./Input/TextInput.js";
import { DatepickerViewsDays as Dn } from "./Views/Days.js";
import { DatepickerViewsDecades as Pn } from "./Views/Decades.js";
import { DatepickerViewsMonth as xn } from "./Views/Months.js";
import { DatepickerViewsYears as Mn } from "./Views/Years.js";
var fe, at;
function Ln() {
  if (at) return fe;
  at = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return fe = e, fe;
}
var ve, nt;
function ee() {
  if (nt) return ve;
  nt = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return ve = e, ve;
}
var le, it;
function re() {
  if (it) return le;
  it = 1;
  var e = ee();
  function r(t, a) {
    for (var n = t.length; n--; )
      if (e(t[n][0], a))
        return n;
    return -1;
  }
  return le = r, le;
}
var he, st;
function Nn() {
  if (st) return he;
  st = 1;
  var e = re(), r = Array.prototype, t = r.splice;
  function a(n) {
    var i = this.__data__, s = e(i, n);
    if (s < 0)
      return !1;
    var u = i.length - 1;
    return s == u ? i.pop() : t.call(i, s, 1), --this.size, !0;
  }
  return he = a, he;
}
var pe, ut;
function kn() {
  if (ut) return pe;
  ut = 1;
  var e = re();
  function r(t) {
    var a = this.__data__, n = e(a, t);
    return n < 0 ? void 0 : a[n][1];
  }
  return pe = r, pe;
}
var de, ot;
function En() {
  if (ot) return de;
  ot = 1;
  var e = re();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return de = r, de;
}
var _e, ct;
function Gn() {
  if (ct) return _e;
  ct = 1;
  var e = re();
  function r(t, a) {
    var n = this.__data__, i = e(n, t);
    return i < 0 ? (++this.size, n.push([t, a])) : n[i][1] = a, this;
  }
  return _e = r, _e;
}
var be, ft;
function te() {
  if (ft) return be;
  ft = 1;
  var e = Ln(), r = Nn(), t = kn(), a = En(), n = Gn();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, be = i, be;
}
var ye, vt;
function Fn() {
  if (vt) return ye;
  vt = 1;
  var e = te();
  function r() {
    this.__data__ = new e(), this.size = 0;
  }
  return ye = r, ye;
}
var ge, lt;
function Hn() {
  if (lt) return ge;
  lt = 1;
  function e(r) {
    var t = this.__data__, a = t.delete(r);
    return this.size = t.size, a;
  }
  return ge = e, ge;
}
var qe, ht;
function Vn() {
  if (ht) return qe;
  ht = 1;
  function e(r) {
    return this.__data__.get(r);
  }
  return qe = e, qe;
}
var me, pt;
function Un() {
  if (pt) return me;
  pt = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return me = e, me;
}
var Ce, dt;
function Ka() {
  if (dt) return Ce;
  dt = 1;
  var e = typeof W == "object" && W && W.Object === Object && W;
  return Ce = e, Ce;
}
var Re, _t;
function H() {
  if (_t) return Re;
  _t = 1;
  var e = Ka(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return Re = t, Re;
}
var Oe, bt;
function za() {
  if (bt) return Oe;
  bt = 1;
  var e = H(), r = e.Symbol;
  return Oe = r, Oe;
}
var Te, yt;
function Bn() {
  if (yt) return Te;
  yt = 1;
  var e = za(), r = Object.prototype, t = r.hasOwnProperty, a = r.toString, n = e ? e.toStringTag : void 0;
  function i(s) {
    var u = t.call(s, n), o = s[n];
    try {
      s[n] = void 0;
      var c = !0;
    } catch {
    }
    var f = a.call(s);
    return c && (u ? s[n] = o : delete s[n]), f;
  }
  return Te = i, Te;
}
var Ae, gt;
function Kn() {
  if (gt) return Ae;
  gt = 1;
  var e = Object.prototype, r = e.toString;
  function t(a) {
    return r.call(a);
  }
  return Ae = t, Ae;
}
var je, qt;
function ae() {
  if (qt) return je;
  qt = 1;
  var e = za(), r = Bn(), t = Kn(), a = "[object Null]", n = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function s(u) {
    return u == null ? u === void 0 ? n : a : i && i in Object(u) ? r(u) : t(u);
  }
  return je = s, je;
}
var Ie, mt;
function E() {
  if (mt) return Ie;
  mt = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return Ie = e, Ie;
}
var we, Ct;
function Jr() {
  if (Ct) return we;
  Ct = 1;
  var e = ae(), r = E(), t = "[object AsyncFunction]", a = "[object Function]", n = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(u) {
    if (!r(u))
      return !1;
    var o = e(u);
    return o == a || o == n || o == t || o == i;
  }
  return we = s, we;
}
var Se, Rt;
function zn() {
  if (Rt) return Se;
  Rt = 1;
  var e = H(), r = e["__core-js_shared__"];
  return Se = r, Se;
}
var De, Ot;
function $n() {
  if (Ot) return De;
  Ot = 1;
  var e = zn(), r = (function() {
    var a = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  })();
  function t(a) {
    return !!r && r in a;
  }
  return De = t, De;
}
var Pe, Tt;
function Yn() {
  if (Tt) return Pe;
  Tt = 1;
  var e = Function.prototype, r = e.toString;
  function t(a) {
    if (a != null) {
      try {
        return r.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  return Pe = t, Pe;
}
var xe, At;
function Jn() {
  if (At) return xe;
  At = 1;
  var e = Jr(), r = $n(), t = E(), a = Yn(), n = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, u = Object.prototype, o = s.toString, c = u.hasOwnProperty, f = RegExp(
    "^" + o.call(c).replace(n, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!t(h) || r(h))
      return !1;
    var m = e(h) ? f : i;
    return m.test(a(h));
  }
  return xe = l, xe;
}
var Me, jt;
function Wn() {
  if (jt) return Me;
  jt = 1;
  function e(r, t) {
    return r?.[t];
  }
  return Me = e, Me;
}
var Le, It;
function Wr() {
  if (It) return Le;
  It = 1;
  var e = Jn(), r = Wn();
  function t(a, n) {
    var i = r(a, n);
    return e(i) ? i : void 0;
  }
  return Le = t, Le;
}
var Ne, wt;
function $a() {
  if (wt) return Ne;
  wt = 1;
  var e = Wr(), r = H(), t = e(r, "Map");
  return Ne = t, Ne;
}
var ke, St;
function ne() {
  if (St) return ke;
  St = 1;
  var e = Wr(), r = e(Object, "create");
  return ke = r, ke;
}
var Ee, Dt;
function Xn() {
  if (Dt) return Ee;
  Dt = 1;
  var e = ne();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ee = r, Ee;
}
var Ge, Pt;
function Zn() {
  if (Pt) return Ge;
  Pt = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return Ge = e, Ge;
}
var Fe, xt;
function Qn() {
  if (xt) return Fe;
  xt = 1;
  var e = ne(), r = "__lodash_hash_undefined__", t = Object.prototype, a = t.hasOwnProperty;
  function n(i) {
    var s = this.__data__;
    if (e) {
      var u = s[i];
      return u === r ? void 0 : u;
    }
    return a.call(s, i) ? s[i] : void 0;
  }
  return Fe = n, Fe;
}
var He, Mt;
function ei() {
  if (Mt) return He;
  Mt = 1;
  var e = ne(), r = Object.prototype, t = r.hasOwnProperty;
  function a(n) {
    var i = this.__data__;
    return e ? i[n] !== void 0 : t.call(i, n);
  }
  return He = a, He;
}
var Ve, Lt;
function ri() {
  if (Lt) return Ve;
  Lt = 1;
  var e = ne(), r = "__lodash_hash_undefined__";
  function t(a, n) {
    var i = this.__data__;
    return this.size += this.has(a) ? 0 : 1, i[a] = e && n === void 0 ? r : n, this;
  }
  return Ve = t, Ve;
}
var Ue, Nt;
function ti() {
  if (Nt) return Ue;
  Nt = 1;
  var e = Xn(), r = Zn(), t = Qn(), a = ei(), n = ri();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, Ue = i, Ue;
}
var Be, kt;
function ai() {
  if (kt) return Be;
  kt = 1;
  var e = ti(), r = te(), t = $a();
  function a() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return Be = a, Be;
}
var Ke, Et;
function ni() {
  if (Et) return Ke;
  Et = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return Ke = e, Ke;
}
var ze, Gt;
function ie() {
  if (Gt) return ze;
  Gt = 1;
  var e = ni();
  function r(t, a) {
    var n = t.__data__;
    return e(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
  }
  return ze = r, ze;
}
var $e, Ft;
function ii() {
  if (Ft) return $e;
  Ft = 1;
  var e = ie();
  function r(t) {
    var a = e(this, t).delete(t);
    return this.size -= a ? 1 : 0, a;
  }
  return $e = r, $e;
}
var Ye, Ht;
function si() {
  if (Ht) return Ye;
  Ht = 1;
  var e = ie();
  function r(t) {
    return e(this, t).get(t);
  }
  return Ye = r, Ye;
}
var Je, Vt;
function ui() {
  if (Vt) return Je;
  Vt = 1;
  var e = ie();
  function r(t) {
    return e(this, t).has(t);
  }
  return Je = r, Je;
}
var We, Ut;
function oi() {
  if (Ut) return We;
  Ut = 1;
  var e = ie();
  function r(t, a) {
    var n = e(this, t), i = n.size;
    return n.set(t, a), this.size += n.size == i ? 0 : 1, this;
  }
  return We = r, We;
}
var Xe, Bt;
function ci() {
  if (Bt) return Xe;
  Bt = 1;
  var e = ai(), r = ii(), t = si(), a = ui(), n = oi();
  function i(s) {
    var u = -1, o = s == null ? 0 : s.length;
    for (this.clear(); ++u < o; ) {
      var c = s[u];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = a, i.prototype.set = n, Xe = i, Xe;
}
var Ze, Kt;
function fi() {
  if (Kt) return Ze;
  Kt = 1;
  var e = te(), r = $a(), t = ci(), a = 200;
  function n(i, s) {
    var u = this.__data__;
    if (u instanceof e) {
      var o = u.__data__;
      if (!r || o.length < a - 1)
        return o.push([i, s]), this.size = ++u.size, this;
      u = this.__data__ = new t(o);
    }
    return u.set(i, s), this.size = u.size, this;
  }
  return Ze = n, Ze;
}
var Qe, zt;
function vi() {
  if (zt) return Qe;
  zt = 1;
  var e = te(), r = Fn(), t = Hn(), a = Vn(), n = Un(), i = fi();
  function s(u) {
    var o = this.__data__ = new e(u);
    this.size = o.size;
  }
  return s.prototype.clear = r, s.prototype.delete = t, s.prototype.get = a, s.prototype.has = n, s.prototype.set = i, Qe = s, Qe;
}
var er, $t;
function Ya() {
  if ($t) return er;
  $t = 1;
  var e = Wr(), r = (function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  })();
  return er = r, er;
}
var rr, Yt;
function Xr() {
  if (Yt) return rr;
  Yt = 1;
  var e = Ya();
  function r(t, a, n) {
    a == "__proto__" && e ? e(t, a, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : t[a] = n;
  }
  return rr = r, rr;
}
var tr, Jt;
function Ja() {
  if (Jt) return tr;
  Jt = 1;
  var e = Xr(), r = ee();
  function t(a, n, i) {
    (i !== void 0 && !r(a[n], i) || i === void 0 && !(n in a)) && e(a, n, i);
  }
  return tr = t, tr;
}
var ar, Wt;
function li() {
  if (Wt) return ar;
  Wt = 1;
  function e(r) {
    return function(t, a, n) {
      for (var i = -1, s = Object(t), u = n(t), o = u.length; o--; ) {
        var c = u[r ? o : ++i];
        if (a(s[c], c, s) === !1)
          break;
      }
      return t;
    };
  }
  return ar = e, ar;
}
var nr, Xt;
function hi() {
  if (Xt) return nr;
  Xt = 1;
  var e = li(), r = e();
  return nr = r, nr;
}
var z = { exports: {} };
z.exports;
var Zt;
function pi() {
  return Zt || (Zt = 1, (function(e, r) {
    var t = H(), a = r && !r.nodeType && r, n = a && !0 && e && !e.nodeType && e, i = n && n.exports === a, s = i ? t.Buffer : void 0, u = s ? s.allocUnsafe : void 0;
    function o(c, f) {
      if (f)
        return c.slice();
      var l = c.length, h = u ? u(l) : new c.constructor(l);
      return c.copy(h), h;
    }
    e.exports = o;
  })(z, z.exports)), z.exports;
}
var ir, Qt;
function di() {
  if (Qt) return ir;
  Qt = 1;
  var e = H(), r = e.Uint8Array;
  return ir = r, ir;
}
var sr, ea;
function _i() {
  if (ea) return sr;
  ea = 1;
  var e = di();
  function r(t) {
    var a = new t.constructor(t.byteLength);
    return new e(a).set(new e(t)), a;
  }
  return sr = r, sr;
}
var ur, ra;
function bi() {
  if (ra) return ur;
  ra = 1;
  var e = _i();
  function r(t, a) {
    var n = a ? e(t.buffer) : t.buffer;
    return new t.constructor(n, t.byteOffset, t.length);
  }
  return ur = r, ur;
}
var or, ta;
function yi() {
  if (ta) return or;
  ta = 1;
  function e(r, t) {
    var a = -1, n = r.length;
    for (t || (t = Array(n)); ++a < n; )
      t[a] = r[a];
    return t;
  }
  return or = e, or;
}
var cr, aa;
function gi() {
  if (aa) return cr;
  aa = 1;
  var e = E(), r = Object.create, t = /* @__PURE__ */ (function() {
    function a() {
    }
    return function(n) {
      if (!e(n))
        return {};
      if (r)
        return r(n);
      a.prototype = n;
      var i = new a();
      return a.prototype = void 0, i;
    };
  })();
  return cr = t, cr;
}
var fr, na;
function qi() {
  if (na) return fr;
  na = 1;
  function e(r, t) {
    return function(a) {
      return r(t(a));
    };
  }
  return fr = e, fr;
}
var vr, ia;
function Wa() {
  if (ia) return vr;
  ia = 1;
  var e = qi(), r = e(Object.getPrototypeOf, Object);
  return vr = r, vr;
}
var lr, sa;
function Xa() {
  if (sa) return lr;
  sa = 1;
  var e = Object.prototype;
  function r(t) {
    var a = t && t.constructor, n = typeof a == "function" && a.prototype || e;
    return t === n;
  }
  return lr = r, lr;
}
var hr, ua;
function mi() {
  if (ua) return hr;
  ua = 1;
  var e = gi(), r = Wa(), t = Xa();
  function a(n) {
    return typeof n.constructor == "function" && !t(n) ? e(r(n)) : {};
  }
  return hr = a, hr;
}
var pr, oa;
function J() {
  if (oa) return pr;
  oa = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return pr = e, pr;
}
var dr, ca;
function Ci() {
  if (ca) return dr;
  ca = 1;
  var e = ae(), r = J(), t = "[object Arguments]";
  function a(n) {
    return r(n) && e(n) == t;
  }
  return dr = a, dr;
}
var _r, fa;
function Za() {
  if (fa) return _r;
  fa = 1;
  var e = Ci(), r = J(), t = Object.prototype, a = t.hasOwnProperty, n = t.propertyIsEnumerable, i = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return r(s) && a.call(s, "callee") && !n.call(s, "callee");
  };
  return _r = i, _r;
}
var br, va;
function Qa() {
  if (va) return br;
  va = 1;
  var e = Array.isArray;
  return br = e, br;
}
var yr, la;
function en() {
  if (la) return yr;
  la = 1;
  var e = 9007199254740991;
  function r(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return yr = r, yr;
}
var gr, ha;
function Zr() {
  if (ha) return gr;
  ha = 1;
  var e = Jr(), r = en();
  function t(a) {
    return a != null && r(a.length) && !e(a);
  }
  return gr = t, gr;
}
var qr, pa;
function Ri() {
  if (pa) return qr;
  pa = 1;
  var e = Zr(), r = J();
  function t(a) {
    return r(a) && e(a);
  }
  return qr = t, qr;
}
var $ = { exports: {} }, mr, da;
function Oi() {
  if (da) return mr;
  da = 1;
  function e() {
    return !1;
  }
  return mr = e, mr;
}
$.exports;
var _a;
function rn() {
  return _a || (_a = 1, (function(e, r) {
    var t = H(), a = Oi(), n = r && !r.nodeType && r, i = n && !0 && e && !e.nodeType && e, s = i && i.exports === n, u = s ? t.Buffer : void 0, o = u ? u.isBuffer : void 0, c = o || a;
    e.exports = c;
  })($, $.exports)), $.exports;
}
var Cr, ba;
function Ti() {
  if (ba) return Cr;
  ba = 1;
  var e = ae(), r = Wa(), t = J(), a = "[object Object]", n = Function.prototype, i = Object.prototype, s = n.toString, u = i.hasOwnProperty, o = s.call(Object);
  function c(f) {
    if (!t(f) || e(f) != a)
      return !1;
    var l = r(f);
    if (l === null)
      return !0;
    var h = u.call(l, "constructor") && l.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == o;
  }
  return Cr = c, Cr;
}
var Rr, ya;
function Ai() {
  if (ya) return Rr;
  ya = 1;
  var e = ae(), r = en(), t = J(), a = "[object Arguments]", n = "[object Array]", i = "[object Boolean]", s = "[object Date]", u = "[object Error]", o = "[object Function]", c = "[object Map]", f = "[object Number]", l = "[object Object]", h = "[object RegExp]", m = "[object Set]", A = "[object String]", j = "[object WeakMap]", D = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", V = "[object Float64Array]", U = "[object Int8Array]", d = "[object Int16Array]", q = "[object Int32Array]", C = "[object Uint8Array]", b = "[object Uint8ClampedArray]", R = "[object Uint16Array]", _ = "[object Uint32Array]", v = {};
  v[g] = v[V] = v[U] = v[d] = v[q] = v[C] = v[b] = v[R] = v[_] = !0, v[a] = v[n] = v[D] = v[i] = v[x] = v[s] = v[u] = v[o] = v[c] = v[f] = v[l] = v[h] = v[m] = v[A] = v[j] = !1;
  function P(I) {
    return t(I) && r(I.length) && !!v[e(I)];
  }
  return Rr = P, Rr;
}
var Or, ga;
function ji() {
  if (ga) return Or;
  ga = 1;
  function e(r) {
    return function(t) {
      return r(t);
    };
  }
  return Or = e, Or;
}
var Y = { exports: {} };
Y.exports;
var qa;
function Ii() {
  return qa || (qa = 1, (function(e, r) {
    var t = Ka(), a = r && !r.nodeType && r, n = a && !0 && e && !e.nodeType && e, i = n && n.exports === a, s = i && t.process, u = (function() {
      try {
        var o = n && n.require && n.require("util").types;
        return o || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = u;
  })(Y, Y.exports)), Y.exports;
}
var Tr, ma;
function tn() {
  if (ma) return Tr;
  ma = 1;
  var e = Ai(), r = ji(), t = Ii(), a = t && t.isTypedArray, n = a ? r(a) : e;
  return Tr = n, Tr;
}
var Ar, Ca;
function an() {
  if (Ca) return Ar;
  Ca = 1;
  function e(r, t) {
    if (!(t === "constructor" && typeof r[t] == "function") && t != "__proto__")
      return r[t];
  }
  return Ar = e, Ar;
}
var jr, Ra;
function wi() {
  if (Ra) return jr;
  Ra = 1;
  var e = Xr(), r = ee(), t = Object.prototype, a = t.hasOwnProperty;
  function n(i, s, u) {
    var o = i[s];
    (!(a.call(i, s) && r(o, u)) || u === void 0 && !(s in i)) && e(i, s, u);
  }
  return jr = n, jr;
}
var Ir, Oa;
function Si() {
  if (Oa) return Ir;
  Oa = 1;
  var e = wi(), r = Xr();
  function t(a, n, i, s) {
    var u = !i;
    i || (i = {});
    for (var o = -1, c = n.length; ++o < c; ) {
      var f = n[o], l = s ? s(i[f], a[f], f, i, a) : void 0;
      l === void 0 && (l = a[f]), u ? r(i, f, l) : e(i, f, l);
    }
    return i;
  }
  return Ir = t, Ir;
}
var wr, Ta;
function Di() {
  if (Ta) return wr;
  Ta = 1;
  function e(r, t) {
    for (var a = -1, n = Array(r); ++a < r; )
      n[a] = t(a);
    return n;
  }
  return wr = e, wr;
}
var Sr, Aa;
function nn() {
  if (Aa) return Sr;
  Aa = 1;
  var e = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
  function t(a, n) {
    var i = typeof a;
    return n = n ?? e, !!n && (i == "number" || i != "symbol" && r.test(a)) && a > -1 && a % 1 == 0 && a < n;
  }
  return Sr = t, Sr;
}
var Dr, ja;
function Pi() {
  if (ja) return Dr;
  ja = 1;
  var e = Di(), r = Za(), t = Qa(), a = rn(), n = nn(), i = tn(), s = Object.prototype, u = s.hasOwnProperty;
  function o(c, f) {
    var l = t(c), h = !l && r(c), m = !l && !h && a(c), A = !l && !h && !m && i(c), j = l || h || m || A, D = j ? e(c.length, String) : [], x = D.length;
    for (var g in c)
      (f || u.call(c, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      A && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      n(g, x))) && D.push(g);
    return D;
  }
  return Dr = o, Dr;
}
var Pr, Ia;
function xi() {
  if (Ia) return Pr;
  Ia = 1;
  function e(r) {
    var t = [];
    if (r != null)
      for (var a in Object(r))
        t.push(a);
    return t;
  }
  return Pr = e, Pr;
}
var xr, wa;
function Mi() {
  if (wa) return xr;
  wa = 1;
  var e = E(), r = Xa(), t = xi(), a = Object.prototype, n = a.hasOwnProperty;
  function i(s) {
    if (!e(s))
      return t(s);
    var u = r(s), o = [];
    for (var c in s)
      c == "constructor" && (u || !n.call(s, c)) || o.push(c);
    return o;
  }
  return xr = i, xr;
}
var Mr, Sa;
function sn() {
  if (Sa) return Mr;
  Sa = 1;
  var e = Pi(), r = Mi(), t = Zr();
  function a(n) {
    return t(n) ? e(n, !0) : r(n);
  }
  return Mr = a, Mr;
}
var Lr, Da;
function Li() {
  if (Da) return Lr;
  Da = 1;
  var e = Si(), r = sn();
  function t(a) {
    return e(a, r(a));
  }
  return Lr = t, Lr;
}
var Nr, Pa;
function Ni() {
  if (Pa) return Nr;
  Pa = 1;
  var e = Ja(), r = pi(), t = bi(), a = yi(), n = mi(), i = Za(), s = Qa(), u = Ri(), o = rn(), c = Jr(), f = E(), l = Ti(), h = tn(), m = an(), A = Li();
  function j(D, x, g, V, U, d, q) {
    var C = m(D, g), b = m(x, g), R = q.get(b);
    if (R) {
      e(D, g, R);
      return;
    }
    var _ = d ? d(C, b, g + "", D, x, q) : void 0, v = _ === void 0;
    if (v) {
      var P = s(b), I = !P && o(b), w = !P && !I && h(b);
      _ = b, P || I || w ? s(C) ? _ = C : u(C) ? _ = a(C) : I ? (v = !1, _ = r(b, !0)) : w ? (v = !1, _ = t(b, !0)) : _ = [] : l(b) || i(b) ? (_ = C, i(C) ? _ = A(C) : (!f(C) || c(C)) && (_ = n(b))) : v = !1;
    }
    v && (q.set(b, _), U(_, b, V, d, q), q.delete(b)), e(D, g, _);
  }
  return Nr = j, Nr;
}
var kr, xa;
function ki() {
  if (xa) return kr;
  xa = 1;
  var e = vi(), r = Ja(), t = hi(), a = Ni(), n = E(), i = sn(), s = an();
  function u(o, c, f, l, h) {
    o !== c && t(c, function(m, A) {
      if (h || (h = new e()), n(m))
        a(o, c, A, f, u, l, h);
      else {
        var j = l ? l(s(o, A), m, A + "", o, c, h) : void 0;
        j === void 0 && (j = m), r(o, A, j);
      }
    }, i);
  }
  return kr = u, kr;
}
var Er, Ma;
function un() {
  if (Ma) return Er;
  Ma = 1;
  function e(r) {
    return r;
  }
  return Er = e, Er;
}
var Gr, La;
function Ei() {
  if (La) return Gr;
  La = 1;
  function e(r, t, a) {
    switch (a.length) {
      case 0:
        return r.call(t);
      case 1:
        return r.call(t, a[0]);
      case 2:
        return r.call(t, a[0], a[1]);
      case 3:
        return r.call(t, a[0], a[1], a[2]);
    }
    return r.apply(t, a);
  }
  return Gr = e, Gr;
}
var Fr, Na;
function Gi() {
  if (Na) return Fr;
  Na = 1;
  var e = Ei(), r = Math.max;
  function t(a, n, i) {
    return n = r(n === void 0 ? a.length - 1 : n, 0), function() {
      for (var s = arguments, u = -1, o = r(s.length - n, 0), c = Array(o); ++u < o; )
        c[u] = s[n + u];
      u = -1;
      for (var f = Array(n + 1); ++u < n; )
        f[u] = s[u];
      return f[n] = i(c), e(a, this, f);
    };
  }
  return Fr = t, Fr;
}
var Hr, ka;
function Fi() {
  if (ka) return Hr;
  ka = 1;
  function e(r) {
    return function() {
      return r;
    };
  }
  return Hr = e, Hr;
}
var Vr, Ea;
function Hi() {
  if (Ea) return Vr;
  Ea = 1;
  var e = Fi(), r = Ya(), t = un(), a = r ? function(n, i) {
    return r(n, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : t;
  return Vr = a, Vr;
}
var Ur, Ga;
function Vi() {
  if (Ga) return Ur;
  Ga = 1;
  var e = 800, r = 16, t = Date.now;
  function a(n) {
    var i = 0, s = 0;
    return function() {
      var u = t(), o = r - (u - s);
      if (s = u, o > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return n.apply(void 0, arguments);
    };
  }
  return Ur = a, Ur;
}
var Br, Fa;
function Ui() {
  if (Fa) return Br;
  Fa = 1;
  var e = Hi(), r = Vi(), t = r(e);
  return Br = t, Br;
}
var Kr, Ha;
function Bi() {
  if (Ha) return Kr;
  Ha = 1;
  var e = un(), r = Gi(), t = Ui();
  function a(n, i) {
    return t(r(n, i, e), n + "");
  }
  return Kr = a, Kr;
}
var zr, Va;
function Ki() {
  if (Va) return zr;
  Va = 1;
  var e = ee(), r = Zr(), t = nn(), a = E();
  function n(i, s, u) {
    if (!a(u))
      return !1;
    var o = typeof s;
    return (o == "number" ? r(u) && t(s, u.length) : o == "string" && s in u) ? e(u[s], i) : !1;
  }
  return zr = n, zr;
}
var $r, Ua;
function zi() {
  if (Ua) return $r;
  Ua = 1;
  var e = Bi(), r = Ki();
  function t(a) {
    return e(function(n, i) {
      var s = -1, u = i.length, o = u > 1 ? i[u - 1] : void 0, c = u > 2 ? i[2] : void 0;
      for (o = a.length > 3 && typeof o == "function" ? (u--, o) : void 0, c && r(i[0], i[1], c) && (o = u < 3 ? void 0 : o, u = 1), n = Object(n); ++s < u; ) {
        var f = i[s];
        f && a(n, f, s, o);
      }
      return n;
    });
  }
  return $r = t, $r;
}
var Yr, Ba;
function $i() {
  if (Ba) return Yr;
  Ba = 1;
  var e = ki(), r = zi(), t = r(function(a, n, i) {
    e(a, n, i);
  });
  return Yr = t, Yr;
}
var Yi = $i();
const Ji = /* @__PURE__ */ bn(Yi), Wi = ({
  title: e,
  open: r,
  inline: t = !1,
  autoHide: a = !0,
  // Hide when selected the day
  showClearButton: n = !0,
  labelClearButton: i = "Clear",
  showTodayButton: s = !0,
  labelTodayButton: u = "Today",
  defaultDate: o,
  minDate: c,
  maxDate: f,
  language: l = "en",
  weekStart: h = An.Sunday,
  className: m,
  onSelectedDateChanged: A,
  value: j,
  compact: D,
  dateRangeType: x,
  theme: g,
  ...V
}, U) => {
  const d = g ? Ji(rt, g) : rt, q = gn(() => {
    if (!j)
      return null;
    const p = new Date(j);
    return isNaN(p.getTime()) ? null : p;
  }, [j]), C = o ? tt(o, c, f) : null, [b, R] = K(r), [_, v] = K(y.Days), [P, I] = K("");
  oe(() => {
    I(
      q ? X(l, q) : ""
    );
  }, [l, q]);
  const [w, L] = K(() => q && !isNaN(q.getTime()) ? q : C || /* @__PURE__ */ new Date()), N = ce(null), se = ce(null), [on, cn] = K({}), G = qn(() => {
    if (!N.current) return;
    const p = N.current.getBoundingClientRect();
    cn({
      position: "fixed",
      top: p.bottom + 8,
      left: p.left,
      zIndex: 9999
    });
  }, []);
  oe(() => {
    if (!(!b || t))
      return G(), window.addEventListener("scroll", G, !0), window.addEventListener("resize", G), () => {
        window.removeEventListener("scroll", G, !0), window.removeEventListener("resize", G);
      };
  }, [b, t, G]);
  const ue = ce({
    date: q,
    shouldUpdate: !0
  }), k = (p, O) => {
    if (!p) {
      I(""), A(null);
      return;
    }
    const S = new Date(p);
    if (isNaN(S.getTime())) {
      I(""), A(null);
      return;
    }
    const F = tt(S, c, f);
    L(F || C || /* @__PURE__ */ new Date()), I(X(l, F)), ue.current = { date: F, shouldUpdate: !0 }, A(F), a && _ === y.Days && O && !t && R(!1);
  }, Qr = () => {
    k(C, !0), o && L(o);
  };
  mn(U, () => ({
    focus() {
      N.current?.focus();
    },
    clear() {
      Qr();
    }
  }));
  const fn = (p) => {
    switch (p) {
      case y.Decades:
        return /* @__PURE__ */ T(Pn, {});
      case y.Years:
        return /* @__PURE__ */ T(Mn, {});
      case y.Months:
        return /* @__PURE__ */ T(xn, {});
      case y.Days:
      default:
        return /* @__PURE__ */ T(Dn, {});
    }
  }, vn = () => {
    switch (_) {
      case y.Days:
        return y.Months;
      case y.Months:
        return y.Years;
      case y.Years:
        return y.Days;
    }
    return _;
  }, ln = () => {
    switch (_) {
      case y.Decades:
        return `${Q(w, 100)} - ${Q(w, 100) + 90}`;
      case y.Years:
        return `${Q(w, 10)} - ${Q(w, 10) + 9}`;
      case y.Months:
        return X(l, w, {
          year: "numeric"
        });
      case y.Days:
      default:
        return X(l, w, {
          month: "long",
          year: "numeric"
        });
    }
  }, et = (p, O, S) => {
    switch (p) {
      case y.Days:
        return new Date(In(O, S));
      case y.Months:
        return new Date(Z(O, S));
      case y.Years:
        return new Date(Z(O, S * 10));
      case y.Decades:
        return new Date(Z(O, S * 100));
      default:
        return new Date(Z(O, S * 10));
    }
  }, hn = (p) => {
    v(y.Days);
    const O = new Date(p.target.value);
    if (I(p.target.value), !isNaN(O.getTime())) {
      R(!0), L(O);
      return;
    }
    R(!1);
  }, pn = (p) => {
    p.key === "Enter" && (N.current?.blur(), R(!1)), p.key === "Escape" && k(ue.current.date, !0);
  }, dn = () => {
    if (P == null) {
      k(null, !0);
      return;
    }
    const p = new Date(P);
    if (isNaN(p.getTime())) {
      k(ue.current.date, !0);
      return;
    }
    k(p, !1);
  };
  return oe(() => {
    const p = (S) => {
      const F = se?.current?.contains(
        S.target
      ), _n = N?.current?.contains(
        S.target
      );
      !F && !_n && R(!1);
    }, O = (S) => {
      S.key === "Escape" && R(!1);
    };
    return document.addEventListener("keydown", O), document.addEventListener("mousedown", p), () => {
      document.removeEventListener("keydown", O), document.removeEventListener("mousedown", p);
    };
  }, [N, se, R]), /* @__PURE__ */ T(
    wn.Provider,
    {
      value: {
        theme: d,
        language: l,
        minDate: c,
        maxDate: f,
        weekStart: h,
        isOpen: b,
        setIsOpen: R,
        view: _,
        setView: v,
        viewDate: w,
        setViewDate: L,
        selectedDate: q,
        changeSelectedDate: k,
        dateRangeType: x
      },
      children: /* @__PURE__ */ B("div", { className: M(d.root.base, m), children: [
        !t && /* @__PURE__ */ T(
          Sn,
          {
            icon: Rn,
            ref: N,
            onClick: () => {
              R(!0);
            },
            onFocus: () => {
              jn(w, q) || L(q || /* @__PURE__ */ new Date()), R(!0);
            },
            value: P || "",
            onChange: hn,
            onBlur: dn,
            onKeyDown: pn,
            compact: D,
            ...V
          }
        ),
        (b || t) && (() => {
          const p = /* @__PURE__ */ T(
            "div",
            {
              ref: se,
              onKeyDown: (O) => {
                O.key === "Escape" && R(!1);
              },
              className: M(
                t ? M(d.popup.root.base, d.popup.root.inline) : "block pt-2"
              ),
              style: t ? void 0 : on,
              children: /* @__PURE__ */ B("div", { className: d.popup.root.inner, children: [
                /* @__PURE__ */ B("div", { className: d.popup.header.base, children: [
                  e && /* @__PURE__ */ T("div", { className: d.popup.header.title, children: e }),
                  /* @__PURE__ */ B(
                    "div",
                    {
                      className: d.popup.header.selectors.base,
                      children: [
                        /* @__PURE__ */ T(
                          "button",
                          {
                            type: "button",
                            className: M(
                              d.popup.header.selectors.button.base,
                              d.popup.header.selectors.button.prev
                            ),
                            onClick: () => L(
                              et(
                                _,
                                w,
                                -1
                              )
                            ),
                            children: /* @__PURE__ */ T(On, {})
                          }
                        ),
                        /* @__PURE__ */ T(
                          "button",
                          {
                            type: "button",
                            className: M(
                              d.popup.header.selectors.button.base,
                              d.popup.header.selectors.button.view
                            ),
                            onClick: () => v(vn()),
                            children: ln()
                          }
                        ),
                        /* @__PURE__ */ T(
                          "button",
                          {
                            type: "button",
                            className: M(
                              d.popup.header.selectors.button.base,
                              d.popup.header.selectors.button.next
                            ),
                            onClick: () => L(
                              et(
                                _,
                                w,
                                1
                              )
                            ),
                            children: /* @__PURE__ */ T(Tn, {})
                          }
                        )
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ T("div", { className: d.popup.view.base, children: fn(_) }),
                (n || s) && /* @__PURE__ */ B("div", { className: d.popup.footer.base, children: [
                  s && /* @__PURE__ */ T(
                    "button",
                    {
                      type: "button",
                      className: M(
                        d.popup.footer.button.base,
                        d.popup.footer.button.today
                      ),
                      onClick: () => {
                        k(/* @__PURE__ */ new Date(), !0);
                      },
                      children: u
                    }
                  ),
                  n && /* @__PURE__ */ T(
                    "button",
                    {
                      type: "button",
                      className: M(
                        d.popup.footer.button.base,
                        d.popup.footer.button.clear
                      ),
                      onClick: () => {
                        Qr();
                      },
                      children: i
                    }
                  )
                ] })
              ] })
            }
          );
          return t ? p : Cn.createPortal(p, document.body);
        })()
      ] })
    }
  );
}, Xi = yn(Wi);
Xi.displayName = "Datepicker";
export {
  Xi as Datepicker
};
